import { useEffect, useRef, useState } from "react";
import "./studio.css";
import studioImg from "../../assets/kids-study-bedroom.png";

// This image stays fixed — it does not change with the Hero carousel.
const STUDIO_IMAGE = {
  src: studioImg,
  alt: "Studio dining room interior",
};

const STUDIO_NAME = "Dwellora Living";

const STATS = [
  { value: 42, suffix: "", label: "Projects" },
  { value: 10, suffix: "", label: "Years" },
  { value: 5, suffix: "", label: "Cities" },
  { value: 10, suffix: "+", label: "Manufacturer" },
];

function StatCounter({ value, suffix }) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);

  useEffect(() => {
    const node = ref.current;
    if (!node || typeof IntersectionObserver === "undefined") return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        observer.disconnect();

        const duration = 1200;
        const start = performance.now();

        const tick = (now) => {
          const progress = Math.min((now - start) / duration, 1);
          setCount(Math.floor(progress * value));
          if (progress < 1) requestAnimationFrame(tick);
        };

        requestAnimationFrame(tick);
      },
      { threshold: 0.4 }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [value]);

  return (
    <span ref={ref}>
      {count}
      {suffix && <sup className="studio-num-suffix">{suffix}</sup>}
    </span>
  );
}

export default function Studio() {
  return (
    <section className="studio-section studio-band-paper studio-root" aria-labelledby="studio-h">
      <div className="studio-wrap studio-grid">
        <div className="studio-media">
          <img src={STUDIO_IMAGE.src} alt={STUDIO_IMAGE.alt} loading="lazy" />
        </div>

        <div className="studio-content">
          <p className="studio-label">The Studio</p>
          <h2 id="studio-h" className="studio-display studio-d-md" style={{ marginTop: "1rem" }}>
            A small practice, deliberately.
          </h2>
          <p className="studio-lede" style={{ marginTop: "1.5rem" }}>
            {STUDIO_NAME} works on a limited number of projects each year so
            that architecture, interior and detail stay in the same pair of
            hands from first sketch to handover.
          </p>

          <div style={{ marginTop: "2rem" }}>
            <a
              href="/contact"
              className="studio-btn"
              onClick={(event) => {
                event.preventDefault();
                window.dispatchEvent(new CustomEvent("dwellora:open-contact"));
              }}
            >
              <span>Talk to a Designer</span>
              <svg
                className="studio-arrow"
                width="14"
                height="14"
                viewBox="0 0 16 16"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M1 15L15 1M15 1H5M15 1V11"
                  stroke="currentColor"
                  strokeWidth="1.2"
                />
              </svg>
            </a>
          </div>

          <div className="studio-stats">
            {STATS.map((stat) => (
              <div key={stat.label}>
                <p className="studio-num">
                  <StatCounter value={stat.value} suffix={stat.suffix} />
                </p>
                <p className="studio-label" style={{ marginTop: "0.4rem" }}>
                  {stat.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
